import { QUOTATION_PRICE_FLAG } from '@/constants';
import { isNil } from '@uno-next/utils';

/**
 * 是否为询价
 * @param price
 */
export const isQuotation = (price?: number | string) => {
  if (isNil(price)) {
    return false;
  }

  const priceNum = +price!;

  if (Number.isNaN(priceNum)) {
    return false;
  }

  return priceNum === QUOTATION_PRICE_FLAG;
};

interface IOption {
  label: string;
  value: string | number;
}

/** options 列表转换为 map */
export const toMapByOptions = (options?: IOption[]) =>
  (options || []).reduce((prev, cur) => ({ ...prev, [cur.value]: cur.label }), {});
